import {
  PriceListItemCalculateType,
  type ProductPriceListItem,
} from "@exonn/js-sdk";

export const computeFinalPriceListItemPrice = ({
  priceListItem: priceListValues,
  price,
}: {
  priceListItem: ProductPriceListItem;
  price: number;
}) => {
  if (priceListValues.calculate_type === PriceListItemCalculateType.Absolute) {
    return price + +priceListValues.calculate_value;
  }

  if (priceListValues.calculate_type === PriceListItemCalculateType.Percent) {
    const percent = +priceListValues.calculate_value;
    return applyPercent(price, percent);
  }

  if (priceListValues.calculate_type === PriceListItemCalculateType.Inactive) {
    return 0;
  }

  if (priceListValues.calculate_type === PriceListItemCalculateType.Fixed) {
    return +priceListValues.calculate_value;
  }

  return 0;
};

const applyPercent = (price: number, percent: number) => {
  return +price + (+price / 100) * +percent;
};
